import React, { useState } from 'react';
import Button from 'web/components/Button';
import styled from "styled-components";
import states from 'states-us';
import { Form, Formik } from 'formik';
import Select from 'web/components/form-elements/Select';
import TextInput from 'web/components/form-elements/TextInput';
import * as moment from "moment";
import DatePicker from "web/components/DatePicker";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


export default ({ isOpen, isRecurrenceFilter, requestedFromDate, requestedToDate, filterModalValues, toggle, fromDateCallBack, toDateCallBack, callBack, filterType }) => {

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = [{
    value: 'All',
    label: 'All',
    isoCode: ''
  }]

  for (let i = 0; i < territoryStates.length; i++) {
    if (territoryStates[i].name !== 'District Of Columbia') {
      let obj = {
        value: territoryStates[i].name,
        label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
        isoCode: territoryStates[i].abbreviation
      }
      stateArr.push(obj)
    }
  }

  let needStatus = [
    {
      value: "ALL",
      label: "All",
    },
    {
      value: "RECEIVED",
      label: "Bid Received",
    },
    {
      value: "ACCEPTED",
      label: "Bid Accepted",
    },
    {
      value: "DECLINED",
      label: "Bid Declined",
    },
    {
      value: "WITHDRAW",
      label: "Bid Withdrawn",
    }
  ]
  let inventoryStatus = [
    {
      value: "ALL",
      label: "All",
    },
    {
      value: "PENDING",
      label: "Offer Received",
    },
    {
      value: "ACCEPTED",
      label: "Accepted",
    },
    {
      value: "REJECTED",
      label: "Declined",
    },
    {
      value: "WITHDRAW",
      label: "Withdrawn",
    },
    {
      value: "TIMEOUT",
      label: "BuyNow Timeout",
    }
  ]
  const getRegisterInitialValues = () => {

    let toDate = new Date();
    let fromDate = new Date();
    let todayDate = new Date();
    todayDate.setDate(todayDate.getDate());

    if (filterType !== "NEED") {
      fromDate.setMonth(fromDate.getMonth() - 1)
    } else {
      toDate.setDate(toDate.getDate() + 10);
      fromDate.setDate(fromDate.getDate() - 20);
    }
    return {
      city: filterModalValues?.city || '',
      state: filterModalValues?.state || 'All',
      postName: filterModalValues?.postName || '',
      status: filterModalValues?.status || 'ALL',
      fromDate: requestedFromDate ? requestedFromDate : fromDate.toISOString().substring(0, 10),
      toDate: requestedToDate ? requestedToDate : toDate.toISOString().substring(0, 10),
    };
  }
  const getRegisterSchema = () => { }

  return (
    <div className='recurranceModal'>
      <Modal isOpen={isOpen} centered={true} size="md">
        {/* toggle={() => setFilterPopUpModal(false)} */}
        <ModalHeader toggle={() => { toggle(!isOpen) }}>
          <h6>Filters</h6>
        </ModalHeader>
        <Formik
          validateOnMount
          enableReinitialize={true}
          initialValues={getRegisterInitialValues()}
          validationSchema={getRegisterSchema()}
          onSubmit={(values) => { }}
        >
          {(props) => {
            const { values, setFieldValue, isValid, dirty } = props;
            return (
              <Form className="form">
                <ModalBody>
                  {!isRecurrenceFilter &&
                    <SelectWrapper>
                      <div className='row'>
                        <div className='col-md-12'>
                          <p>{filterType === "NEED" ? "Requested Delivery Date" : "Created Date"}<span className="star">*</span></p>
                          <DatePickerWrapper>
                            <DatePicker name="fromDate" maxDOBirth={requestedToDate} value={requestedFromDate} callBackFun={(date) => {
                              fromDateCallBack(date);
                              setFieldValue('fromDate', moment(date).format(BIDFORMAT))
                            }} />

                            <p style={{ 'margin-top': '5px' }}>To</p>
                            <DatePicker name="toDate" minDOBirth={requestedFromDate} value={requestedToDate} callBackFun={(date) => {
                              toDateCallBack(date);
                              setFieldValue('toDate', moment(date).format(BIDFORMAT))
                            }} />
                          </DatePickerWrapper>
                        </div>
                      </div>
                    </SelectWrapper>
                  }
                  <SelectWrapper className='for-popup'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <p>City</p>
                        <TextInput name="city" inputType="city" placeholder="Enter City" onChangeHandler={(value) => {
                          // setFieldValue('locationZip',"")
                        }} />
                      </div>
                      <div className='col-md-6'>
                        <p>State</p>
                        <Select
                          name="state"
                          data={stateArr}
                          searchable={true}
                          placeholder="Select State"
                          onChangeHandler={() => {
                            // setFieldValue('locationZip',"")
                          }}
                        />
                      </div>
                    </div>

                  </SelectWrapper>
                  <SelectWrapper className='for-popup'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <p>Post Name</p>
                        <TextInput name="postName" placeholder="Enter Post Name" />
                      </div>
                      {!isRecurrenceFilter &&
                        <div className='col-md-6'>
                          <p>{filterType === "NEED" ? "Bid Status" : "Offer Status"}</p>
                          <Select
                            name="status"
                            placeholder="Select Status"
                            data={filterType === "NEED" ? needStatus : inventoryStatus}
                            searchable={true}
                            onChangeHandler={() => {
                            }}
                          />
                        </div>
                      }
                    </div>
                  </SelectWrapper>
                </ModalBody>
                <ModalFooter>
                  <Button
                    type="app-green-button"
                    handleClick={() => {
                      callBack(props?.values)
                    }}
                  >
                    Search
                  </Button>
                </ModalFooter>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </div>
  );
};

const DatePickerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 8px;
  
`

const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  &.for-popup {
    .react-select-container  {
      margin-bottom: 24px;
    }
  }
  > div {
    display: flex;
    p {
      margin: 8px 0;
    }
  }
  select,
  // input {
  //   padding: 5px;
  //   border: solid 1px transparent !important;
  //   margin: 2px 0;
  //   font-size: 16px;
  //   padding: 10px 13px 10px 13px;
  //   border-radius: 5px;
  //   background-color: #e8e2e2;
  //   -webkit-appearance: none;
  //   -moz-appearance: none;
  //   appearance: none;
  //   ::-webkit-input-placeholder {
  //     /* Edge */
  //     color: #656565;
  //   }

  //   :-ms-input-placeholder {
  //     /* Internet Explorer 10-11 */
  //     color: #656565;
  //   }

  //   ::placeholder {
  //     color: #656565;
  //   }
  // }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
`;
